/* ══════════════════════════════════════════════════════════════════════
   about us / 客戶服務 / 常見問題 / 使用說明書 / App 下載 五頁的互動行為。
   逐字對應美國站 https://us.tineco.com/js/support.js 的相同區塊：
     - #support-index-swiper 產品分類輪播（slidesPerView 4 + fraction 分頁）
     - 左右箭頭 #supportIndexSwiperPreBtn / #supportIndexSwiperNextBtn
     - App 下載頁的 iOS / Android 切換
   美國站以 jQuery 撰寫；此處改為原生 JS，行為相同但不依賴 jQuery 載入順序。
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  function init() {
    if (typeof Swiper === 'undefined') return false;

    var el = document.getElementById('support-index-swiper');
    if (el && !el.dataset.hkInit) {
      el.dataset.hkInit = '1';
      var sw = new Swiper('#support-index-swiper', {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: { el: '.swiper-pagination', type: 'fraction' },
        breakpoints: {
          0:   { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1000:{ slidesPerView: 4 }
        }
      });
      var prev = document.getElementById('supportIndexSwiperPreBtn');
      var next = document.getElementById('supportIndexSwiperNextBtn');
      if (prev) prev.addEventListener('click', function () { sw.slidePrev(); });
      if (next) next.addEventListener('click', function () { sw.slideNext(); });
    }
    return true;
  }

  /* App 下載頁：iOS / Android 切換（美國站同名元素 id） */
  function tabs() {
    var and = document.getElementById('androidBtn');
    var ios = document.getElementById('iosBtn');
    var andP = document.getElementById('androidPlant');
    var iosP = document.getElementById('iosPlant');
    if (!and || !ios) return;
    function show(which) {
      if (which === 'android') {
        and.classList.add('and'); ios.classList.remove('and');
        if (andP) andP.style.display = '';
        if (iosP) iosP.style.display = 'none';
      } else {
        ios.classList.add('and'); and.classList.remove('and');
        if (iosP) iosP.style.display = '';
        if (andP) andP.style.display = 'none';
      }
    }
    and.addEventListener('click', function () { show('android'); });
    ios.addEventListener('click', function () { show('ios'); });
  }

  function boot() {
    tabs();
    if (init()) return;
    var n = 0;
    var t = setInterval(function () {        /* Swiper 以 defer 載入，最多重試 20 次 */
      if (init() || ++n > 20) clearInterval(t);
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
